import classNames from 'classnames'
import styles from './WaveyWrapper.module.css'
import { LayoutStack } from '../layouts'
import { WaveyWrapperProps } from './types'
import type { CSSProperties } from 'react'

function WaveyWrapper({ children, bright = false, topOnly, bottomOnly, className, space = 'none' }: WaveyWrapperProps) {
  return (
    <LayoutStack
      space="none"
      className={classNames(styles.outerContainer, {
        [styles.bright!]: bright,
        [styles.dark!]: !bright,
        [styles.bottomOnly!]: bottomOnly,
        [styles.topOnly!]: topOnly,
      })}
      style={
        {
          '--space': `var(--betterplace-spacing-${space})`,
        } as CSSProperties
      }
    >
      <LayoutStack space="400" className={classNames(styles.contentContainer, className)}>
        {children}
      </LayoutStack>
    </LayoutStack>
  )
}

export default WaveyWrapper
